<div class="">
  <!-- {{to | json}} -->
  <label>{{to.label}}</label>
  <input class="formly-field inputClass" type="input" [formControl]="formControl" [formlyAttributes]="field">
</div>